import { isWorkspaceHost } from './siteHosts';

export const AUTH_AUDIENCE_HEADER = 'X-Lewouhmart-Auth-Audience';

export type AuthAudience = 'workspace' | 'storefront';

export function getAuthAudience(): AuthAudience {
  return isWorkspaceHost() ? 'workspace' : 'storefront';
}

export function authAudienceHeaders(): Record<string, string> {
  return { [AUTH_AUDIENCE_HEADER]: getAuthAudience() };
}
